module.exports = __webpack_public_path__ + "img/file-27_icon-icons.com_62081.4b82407c.png";